<template>

  <div v-show="isVisible" class="cf-calc nau-calc">

    <!-- ================= GORA: gradient NAU, suwaki ================= -->
    <div class="nau-calc__top">

      <span class="nau-calc__eyebrow">Twoja pożyczka</span>

      <!-- kwota -->
      <div class="nau-calc__param">
        <div class="cf-calc__row">
          <span class="nau-calc__label">Kwota</span>
          <span class="nau-calc__value">{{ fmtInt(loanAmount) }} <span class="nau-calc__unit">zł</span></span>
        </div>
        <input class="cf-range nau-range" type="range" :min="minAmount" :max="maxAmount" :step="step" :value="loanAmount"
               aria-label="Kwota pożyczki" @input="onAmount" @change="onSlideEnd">
        <div class="nau-range__scale"><span v-for="v in labelValues" :key="v">{{ fmtInt(v) }}</span></div>
      </div>

      <!-- okres -->
      <div class="nau-calc__param">
        <div class="cf-calc__row">
          <span class="nau-calc__label">Okres</span>
          <span class="nau-calc__value">{{ loanTenor }} <span class="nau-calc__unit">{{ tenorSign == 'd' ? 'dni' : 'mies.' }}</span></span>
        </div>
        <input class="cf-range nau-range" type="range" :min="minTenor" :max="maxTenor" :step="tenorStep" :value="loanTenor"
               aria-label="Okres spłaty" @input="onTenor" @change="onSlideEnd">
        <div class="nau-range__scale"><span v-for="l in tenorLabels" :key="l">{{ l }}</span></div>
      </div>

      <!-- formularz informacyjny - jak w poprzednim kalkulatorze, tuz pod suwakami -->
      <a class="nau-calc__info" href="#" @click.prevent="showInfoForm">Formularz informacyjny</a>

    </div>


    <!-- ================= DOL: jasne tlo, kalkulacja ================= -->
    <div class="nau-calc__bottom">

      <dl class="cf-calc__summary">
        <div class="cf-calc__line"><dt>Miesięczna rata</dt><dd>{{ money(installmentAmount) }}</dd></div>
        <div class="cf-calc__line"><dt>Data spłaty</dt><dd>{{ finishDate || '—' }}</dd></div>
        <div class="cf-calc__line"><dt>Prowizja</dt><dd>{{ money(service) }}</dd></div>
        <div class="cf-calc__line"><dt>Oprocentowanie</dt><dd>{{ money(interest) }}</dd></div>
        <div class="cf-calc__line"><dt>RRSO</dt><dd>{{ pct(rrso) }}</dd></div>
        <div class="cf-calc__line cf-calc__line--total"><dt>Razem do spłaty</dt><dd>{{ money(total) }}</dd></div>
      </dl>

      <!-- przyklad reprezentatywny (config.json: loan_sample) -->
      <p v-if="getConf('loan_sample')" class="nau-calc__sample">
        <strong>Przykład reprezentatywny:</strong> {{ getConf('loan_sample') }}
      </p>

    </div>


    <!-- Modal: formularz informacyjny (tresc buduje CalcSlider.setValues -> formText) -->
    <div class="modal fade" ref="modal">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header container dark-bg">
            <div class="col-auto me-auto ">
              <h3>Formularz informacyjny</h3>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-html="formText">
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" class="cf-btn cf-btn--primary" data-bs-dismiss="modal"> Zamknij </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  import CalcSlider from '@/CalcSlider';


  // ---------------------------------------------------------------------------
  // Kalkulator w panelu decyzji formularza wniosku. Uklad nawiazuje do
  // poprzedniego CalcSlidera NAU: gora z zielonym gradientem (suwaki + link do
  // formularza informacyjnego), dol jasny z kalkulacja i przykladem
  // reprezentatywnym. Cala logika (tabela calc_params, setValues, formularz
  // informacyjny) jest dziedziczona z CalcSlider (extends) - tu tylko inny
  // szablon i formatowanie. Wartosci ida przez proxy loanStore z mixina
  // (loanAmount, loanTenor, total, rrso...), wiec kilka instancji
  // (desktop / mobile) jest w synchronie.
  // ---------------------------------------------------------------------------

  export default {

    name: 'NauCalcPanel',

    extends: CalcSlider,


    methods: {

      onAmount(e){

        this.loanAmount = parseInt(e.target.value);
        this.onCalcSlide();
      },


      onTenor(e){

        this.loanTenor = parseInt(e.target.value);
        this.onCalcSlide();
      },


      fmtInt(v){

        return String(Math.round(Number(v) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      },


      money(v){

        let n = parseFloat(v);

        return isNaN(n) ? '—' : this.formatCurrency(n, false) + ' zł';
      },


      pct(v){

        let n = parseFloat(v);

        return isNaN(n) ? '—' : String(v).replace('.', ',') + ' %';
      }
    }

    // modal formularza informacyjnego jest przenoszony do <body> w mounted
    // CalcSlidera (panel boczny jest position: sticky = wlasny stacking
    // context, w ktorym okno ladowalo POD backdropem bootstrapa)
  }

</script>

<style scoped>

  /* karta kalkulatora: gora gradient (jak stary .calc .params), dol jasny */

  .nau-calc {
    border-radius: 22px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 12px 30px rgba(0, 0, 0, .10);
  }

  .nau-calc__top {
    background-image: linear-gradient(0deg, #00605c, #0bc268);
    color: #fff;
    padding: 22px 22px 20px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .nau-calc__eyebrow {
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: .14em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, .8);
  }

  .nau-calc__param {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .nau-calc__label {
    font-size: 15px;
    font-weight: 600;
    color: #fff;
  }

  .nau-calc__value {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: -.5px;
    white-space: nowrap;
    color: #fff;
  }

  .nau-calc__unit {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, .85);
  }

  /* suwaki na gradiencie: jasny tor, biala galka */

  .nau-range {
    background: rgba(255, 255, 255, .35);
    margin: 12px 0 6px;
  }

  .nau-range::-webkit-slider-thumb {
    background: #fff;
    border: 3px solid #007666;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .25);
  }

  .nau-range::-moz-range-thumb {
    background: #fff;
    border: 3px solid #007666;
  }

  .nau-range:focus-visible {
    outline-color: #fff;
  }

  .nau-range__scale {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: rgba(255, 255, 255, .8);
  }

  .nau-calc__info {
    align-self: center;
    color: #fff;
    text-decoration: underline;
    font-size: 13.5px;
    margin-top: 2px;
  }

  .nau-calc__info:hover {
    color: #fff;
    opacity: .85;
  }

  .nau-calc__bottom {
    padding: 8px 22px 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .nau-calc__sample {
    margin: 4px 0 0;
    padding-top: 12px;
    border-top: 1px solid var(--cf-line-soft);
    font-size: 11.5px;
    line-height: 1.55;
    font-style: italic;
    color: var(--cf-ink-3);
    text-align: left;
  }

  .nau-calc__sample strong {
    font-style: normal;
    color: var(--cf-ink-2);
  }

  .modal-dialog {
    max-width: 900px;
  }

  .modal-body {
    overflow-y: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/NauCalcPanel.vue